import { Navigate, useLocation } from 'react-router-dom'

// Bookmarks, server default routes and support-reply emails still carry the old path.
export default function LegacyAdvicePrepRedirect() {
  const { pathname, search, hash } = useLocation()
  return <Navigate replace to={`${pathname.replace(/^\/advisoryai/i, '/adviceprep')}${search}${hash}`} />
}
